import classNames from 'clsx';
import React from 'react';

import styles from './Header.scss';

export enum Variant {
  Dark = 'dark',
  Light = 'light'
}

export interface Props {
  className?: string;
  variant?: Variant;
}

const Header: React.FC<Props> = ({ children, className, variant = Variant.Light }) => (
  <header className={classNames(styles.header, styles[variant], className)}>{children}</header>
);

export default Header;
